import {ajax} from "./preset";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import './index.css';

const root = ReactDOM.createRoot(document.getElementById("root"));

const themeToken = {};

root.render(<React.StrictMode>
    <App preset={{ajax}} themeToken={themeToken}/>
</React.StrictMode>);
